import { useEffect } from "react";
import { ReactLenis } from "lenis/react";
import "@/App.css";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Features from "@/components/landing/Features";
import Manifesto from "@/components/landing/Manifesto";
import Gallery from "@/components/landing/Gallery";
import ComingSoon from "@/components/landing/ComingSoon";
import Contact from "@/components/landing/Contact";

function App() {
  useEffect(() => {
    document.title = "Vacansee — Hiring, Reimagined. Coming Soon.";
  }, []);

  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="relative min-h-screen bg-sand text-ink overflow-x-clip">
        <div className="grain-overlay fixed inset-0 z-[60]" aria-hidden="true" />
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Features />
          <Manifesto />
          <Gallery />
          <ComingSoon />
          <Contact />
        </main>
      </div>
    </ReactLenis>
  );
}

export default App;
